/** Web — Apple IAP is iOS-only. */
export function AppleIapHost() {
  return null;
}
